import { render } from "./MostaSelect.vue?vue&type=template&id=0499c3fa&scoped=true&ts=true"
import script from "./MostaSelect.vue?vue&type=script&lang=ts"
export * from "./MostaSelect.vue?vue&type=script&lang=ts"

import "./MostaSelect.vue?vue&type=style&index=0&id=0499c3fa&lang=scss&scoped=true"
import "./MostaSelect.vue?vue&type=style&index=1&id=0499c3fa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0499c3fa"]])

export default __exports__